interface PatternConfig {
    pattern: 'A' | 'B' | 'C' | 'D'
    percentage: number
}

interface AbTestConfig {
    issueNumber: string
    patterns: PatternConfig[]
    pathRegex: RegExp
    isActive: boolean
}

/**
 * ABテスト設定一覧
 * 新しい施策を追加する場合はここに設定を追加
 * パーセンテージの合計は100%にすること
 *
 * 例: DEV-2966 PF転換フォームのA/Bテスト（Bパターンを本採用したため削除、参考として残置）
 * {
 *     issueNumber: '2966',
 *     patterns: [
 *         { pattern: 'A', percentage: 50 },
 *         { pattern: 'B', percentage: 50 },
 *     ],
 *     pathRegex: /^\/job_seekers\/[^/]+\/edit/,
 *     isActive: true,
 * }
 */
export const AB_TEST_CONFIGS: AbTestConfig[] = [
    // DEV-3482 新規会員登録フォームのABテスト第2弾（foodslaboのみ）
    // /signup?offer_id=... は別ページ（offerRegistration）が同じgetSteps()/ProgressBannerを
    // importしているため、offer_id付きは必ず除外する（除外漏れは求人応募ファネルの計測とステップ順を破壊する）
    {
        issueNumber: '3482',
        patterns: [
            { pattern: 'A', percentage: 40 },
            { pattern: 'B', percentage: 30 },
            { pattern: 'C', percentage: 30 },
        ],
        pathRegex: /^\/signup\/?(?!.*[?&]offer_id=)(\?.*)?$/,
        isActive: true,
    },
]

export type { PatternConfig, AbTestConfig }
